module.exports = __webpack_public_path__ + "img/TYS-6.74b591fc.jpg";